'use client';
import { HugeiconsIcon } from '@hugeicons/react';
import {
  FavouriteIcon,
  ShoppingCart01Icon,
  UserIcon,
} from '@hugeicons/core-free-icons';
import { useAppSelector } from '@/lib/redux/hooks';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { useAppDispatch } from '@/lib/redux/hooks';
import { fetchCartItems } from '@/lib/redux/features/cart';
import { useAuth } from '@/features/authentication/hooks/auth';
import NextImage from '@/features/Image';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
const HeaderCart = () => {
  const { user } = useAuth();
  const { data: wishlists } = useFetcherCSR(user && `/api/v2/wishlists`);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const despatch = useAppDispatch();
  const { items } = useAppSelector((state) => state.cart);

  useEffect(() => {
    setTotalQuantity(items.reduce((total, item) => total + item.quantity, 0));
  }, [items]);

  useEffect(() => {
    if (!user) return;
    despatch(fetchCartItems());
  }, [despatch, user]);

  return (
    <>
      <Link
        className="header__action-btn  d-xl-grid cart-link"
        href="/wishlist"
      >
        {/* <FaRegHeart /> */}
        <HugeiconsIcon icon={FavouriteIcon} />
        {wishlists?.data?.length > 0 && (
          <span className="cart-count">{wishlists?.data?.length}</span>
        )}
      </Link>

      <Link className="header__action-btn d-xl-grid cart-link" href="/cart">
        {/* <IoCartOutline /> */}
        <HugeiconsIcon icon={ShoppingCart01Icon} />
        {totalQuantity > 0 && (
          <span className="cart-count">{totalQuantity}</span>
        )}
      </Link>

      <Link className="header__action-btn d-xl-grid" href="/account">
        {/* <FaRegUser /> */}
        {user?.data?.avatar ? (
          <div
            className="d-inline-block rounded-circle overflow-hidden"
            style={{ width: '26.18px', height: '26.18px' }}
          >
            <NextImage
              src={user?.data?.avatar}
              alt={'user Image'}
              width={26.18}
              height={26.18}
              className="w-100 h-100 border-2"
              style={{ objectFit: 'cover' }}
            />
            2222222
          </div>
        ) : (
          <HugeiconsIcon icon={UserIcon} />
        )}
      </Link>
    </>
  );
};

export default HeaderCart;
